import React from 'react';
import { Link } from 'react-router-dom'
import EldcLogo from '../../images/eldc-logo.svg'
import avatar from '../../images/avatar.png'
import Notification from '../../images/notifivation-Icon.png'
import overviewicon from '../../images/overview-icon.svg'
import modulesicon from '../../images/your-modules-icon.svg'
import modulelibrary from '../../images/module-library.svg'
import personalsetting from '../../images/personal-setting.svg'

const Sidbar = () => {
    return (
        <>
            <nav id="mainNav" className="navbar navbar-expand-lg side-bar">
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false"
                    aria-label="Toggle navigation"><span className="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse sec2" id="navbarResponsive">
                    <div class="sec1">
                        {/* <img src="assets/images/eldc-logo.svg" alt=""> */}
                        <img src={EldcLogo} alt="Profile Picture" />
                    </div>
                    <ul className="navbar-nav" >
                        <a href="#" className="h-close">{/* <img src={closecircled} /> */}</a>
                        <li className="active nav-item">
                            {/* <a href="#" className="nav-link"> */}
                            <Link to='/' className='nav-link'>
                                <img src={overviewicon} alt="Profile Picture" />
                                <span>Overview</span>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to='/user-your-mmodule' className='nav-link'>
                                {/* <i className='fas fa-tachometer-alt'></i> */}
                                <img src={modulesicon} alt="Profile Picture" />
                                <span>Your Modules</span>
                            </Link>
                        </li>
                        <li className="nav-item">

                            <Link to='/dashboard' className='nav-link'>
                                {/* <i className='fas fa-tachometer-alt'></i> */}
                                <img src={modulelibrary} alt="Profile Picture" />
                                <span>Competencies</span>
                            </Link>


                        </li>
                        <li className="nav-item">
                            <Link to='/dashboard' className='nav-link'>
                                <img src={personalsetting} alt="Profile Picture" /> <span> Module Library</span>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to='/dashboard' className='nav-link'>
                                <i className='fas fa-tachometer-alt'></i> <span> Personal Settings</span>
                            </Link>
                        </li>
                    </ul>
                    <div className="sec3 prfile">
                        <div className="row justify-content-between">
                            <div className="avatar">
                                {/* <img src={} alt=""> */}
                                <img src={avatar} alt="Profile Picture" />
                            </div>
                            <div className="position-relative">
                                {/* <img src="assets/images/notifivation-Icon.png" alt=""> */}
                                <img src={Notification} alt="Profile Picture" />
                                <span>5</span>
                            </div>
                        </div>


                        <h3>Isabelle Stanley</h3>
                        <span>Admin</span>
                        <p>stanley.i@hotmail.com</p>
                        <a href="#">View profile</a>
                    </div>
                </div>
            </nav>

        </>
    );
};

export default Sidbar;